//@ts-nocheck
import { useState } from 'react'
import Modal from '../Reusable/Modal'
import MakePayment from './MakePayment'
import Button from '../Reusable/Button'
import moment from 'moment'
import APIS from '../../constant/EndPoint'
import useGetHook from '../../customHooks/useGetHook'
import DanfeLogo from "../../assets/favicon.png"


const InvoicePreview = (props: any) => {
  const { businessProfile, order } = props
  const [openPrintPopup, setOpenPrintPDF] = useState(false)
  const [makePayment, setMakePayment] = useState(false)
  const { data: userProfileType } = useGetHook({
    queryKey: [`user-profile`],
    url: `${APIS.USER_PROFILE}`,
    params: {},
  });


  return (
    <>
      <div className="max-w-[85rem] px-4 sm:px-6 mx-auto">
        <div className="sm:w-11/12 lg:w-3/4 mx-auto">
          <div className="mb-6 flex justify-end gap-x-3 ">
            <div className='w-96 flex gap-x-8'>
              <Button
                label="Print"
                type="button"
                onClick={() => setOpenPrintPDF(!openPrintPopup)}
              />
              {userProfileType?.is_merchant ? "" :
                <Button
                  label={order?.status === "paid" ? "PAID" : "Make Payment"}
                  type="button"
                  disabled={order?.status !== "pending"}
                  onClick={() => setMakePayment(!makePayment)}
                />
              }

            </div>

          </div>
          {/* Card */}
          <div className="flex flex-col p-4 sm:p-10 bg-white shadow-md rounded-xl dark:bg-gray-800">
            {/* Grid */}
            <div className="flex justify-between">
              <div>
                <img src={DanfeLogo} alt="" />

                <h1 className="mt-2 text-lg md:text-xl font-semibold text-primary dark:text-white">Danfe Express Pvt. Ltd</h1>
              </div>
              {/* Col */}

              <div className="text-right">
                <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 dark:text-gray-200">Invoice #</h2>
                <span className="mt-1 block text-gray-500">{order?.tracking_number}</span>

                <address className="mt-4 not-italic text-gray-800 dark:text-gray-200">
                  {businessProfile?.address ?? "N/A"}<br />
                  {businessProfile?.city?.name}, {businessProfile?.district?.name}<br />
                  {businessProfile?.state?.name}, {businessProfile?.country?.name ?? "N/A"}<br />
                </address>
              </div>
              {/* Col */}
            </div>
            {/* End Grid */}

            {/* Grid */}
            <div className="mt-8 grid sm:grid-cols-2 gap-3">
              <div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200">Bill to:</h3>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200 capitalize">{order?.merchant?.name ?? "N/A"}</h3>
                <address className="mt-2 not-italic text-gray-500">
                  {order?.merchant?.mobile_number ?? "N/A"},<br />
                  {order?.merchant?.email ?? "N/A"},<br />
                  Kathmandu, Nepal<br />
                </address>
              </div>
              {/* Col */}

              <div className="sm:text-right space-y-2">
                {/* Grid */}
                <div className="grid grid-cols-2 sm:grid-cols-1 gap-3 sm:gap-2">
                  <dl className="grid sm:grid-cols-5 gap-x-3">
                    <dt className="col-span-3 font-semibold text-gray-800 dark:text-gray-200">Invoice date:</dt>
                    <dd className="col-span-2 text-gray-500">{moment(order?.created).format('YYYY/MM/DD HH:mm:ss')}</dd>
                  </dl>
                  <dl className="grid sm:grid-cols-5 gap-x-3">
                    <dt className="col-span-3 font-semibold text-gray-800 dark:text-gray-200">Payment Method:</dt>
                    <dd className="col-span-2 text-gray-500 uppercase">{order?.invoice_payment_history?.map((item: any, index: number) => (<>{item.payment_method}</>))}</dd>
                  </dl>
                  <dl className="grid sm:grid-cols-5 gap-x-3">
                    <dt className="col-span-3 font-semibold text-gray-800 dark:text-gray-200">Payment date:</dt>
                    <dd className="col-span-2 text-gray-500">{order?.paid_date ? moment(order?.paid_date).format('YYYY/MM/DD HH:mm:ss') : "N/A"}</dd>
                  </dl>
                  <dl className="grid sm:grid-cols-5 gap-x-3">
                    <dt className="col-span-3 font-semibold text-gray-800 dark:text-gray-200">Payment Status:</dt>
                    <dd className="col-span-2 text-gray-500 uppercase">{order?.status}</dd>
                  </dl>
                </div>
                {/* End Grid */}
              </div>
              {/* Col */}
            </div>
            {/* End Grid */}

            {/* Table */}
            <div className="mt-6">
              <div className="border border-gray-200 p-4 rounded-lg space-y-4 dark:border-gray-700">
                <div className="hidden sm:grid sm:grid-cols-6">
                  <div className="sm:col-span-2 text-xs font-medium text-gray-500 uppercase">Order</div>
                  <div className="text-left text-xs font-medium text-gray-500 uppercase">COD</div>
                  <div className="text-left text-xs font-medium text-gray-500 uppercase">Cod Collected</div>
                  <div className="text-left text-xs font-medium text-gray-500 uppercase">D. Charge</div>
                  <div className="text-right text-xs font-medium text-gray-500 uppercase">Tax</div>
                </div>

                <div className="hidden sm:block border-b border-gray-200 dark:border-gray-700"></div>
                {order?.invoice_order_items?.map((item: any, index: number) => (

                  <div key={index} className="grid grid-cols-3 sm:grid-cols-6 gap-2">
                    <div className="col-span-full sm:col-span-2">
                      <p className="font-medium text-gray-800 dark:text-gray-200">{item?.order?.customer_full_name}</p>
                    </div>
                    <div>
                      <p className="text-gray-800 dark:text-gray-200 whitespace-nowrap">Rs. {item?.order?.cod}</p>
                    </div>
                    <div>
                      <p className="text-gray-800 dark:text-gray-200 whitespace-nowrap">Rs. {item?.order?.collected_cod ?? 0.00}</p>
                    </div>
                    <div>
                      <p className="text-gray-800 dark:text-gray-200 whitespace-nowrap">Rs. {item?.order?.delivery_charge ?? 0.00}</p>
                    </div>
                    <div>
                      <p className="sm:text-right text-gray-800 dark:text-gray-200 whitespace-nowrap">Rs. 0.00</p>
                    </div>
                  </div>
                ))}

              </div>
            </div>
            {/* End Table */}

            {/* Flex */}
            <div className="mt-8 flex sm:justify-end">
              <div className="w-full max-w-2xl sm:text-right space-y-2">
                {/* Grid */}
                <div className="grid grid-cols-2 sm:grid-cols-1 gap-3 sm:gap-2">
                  <dl className="grid sm:grid-cols-5 gap-x-3">
                    <dt className="col-span-3 font-semibold text-gray-800 dark:text-gray-200">Total Cod:</dt>
                    <dd className="col-span-2 text-gray-500">Rs. {order?.amount}</dd>
                  </dl>

                  <dl className="grid sm:grid-cols-5 gap-x-3">
                    <dt className="col-span-3 font-semibold text-gray-800 dark:text-gray-200">Collected Cod:</dt>
                    <dd className="col-span-2 text-gray-500">Rs. {order?.collected_cod}</dd>
                  </dl>

                  <dl className="grid sm:grid-cols-5 gap-x-3">
                    <dt className="col-span-3 font-semibold text-gray-800 dark:text-gray-200">Deliver Charge:</dt>
                    <dd className="col-span-2 text-gray-500">Rs. {order?.delivery_charge}</dd>
                  </dl>

                  <dl className="grid sm:grid-cols-5 gap-x-3">
                    <dt className="col-span-3 font-semibold text-gray-800 dark:text-gray-200">Tax:</dt>
                    <dd className="col-span-2 text-gray-500">Rs. {order?.tax}</dd>
                  </dl>

                  <dl className="grid sm:grid-cols-5 gap-x-3">
                    <dt className="col-span-3 font-semibold text-gray-800 dark:text-gray-200">Payable Amount:</dt>
                    <dd className="col-span-2 text-gray-500">Rs. {order?.invoice_amount}</dd>
                  </dl>
                </div>
                {/* End Grid */}
              </div>
            </div>
            {/* End Flex */}

            <div className="mt-8 sm:mt-12">
              <h4 className="text-lg font-semibold text-gray-800 dark:text-gray-200">Thank you!</h4>
              <p className="text-gray-500">If you have any questions concerning this invoice, use the following contact information:</p>
              <div className="mt-2">
                <p className="block text-sm font-medium text-gray-800 dark:text-gray-200">{businessProfile?.email}</p>
                <p className="block text-sm font-medium text-gray-800 dark:text-gray-200">{businessProfile?.mobile_number}</p>
              </div>
            </div>

            <p className="mt-5 text-sm text-gray-500">© {new Date().getFullYear()} {businessProfile?.company}.</p>
          </div>
          {/* End Card */}
        </div>
      </div>

      <Modal
        isOpen={makePayment}
        setIsOpen={setMakePayment}
        title={"Make Payment"}
        children={<>
          <MakePayment
            setMakePayment={setMakePayment}
          />
        </>}
      />
    </>
  )
}

export default InvoicePreview
